module.exports = __webpack_public_path__ + "img/palette-2-bg_en.fe69e84.jpg";